var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ReportEdit',_vm._g(_vm._b({},'ReportEdit',{ report: _vm.report, scenes: _vm.scenes, entries: _vm.entries, breadcrumbs: _vm.breadcrumbs },false),{ ok: _vm.ok, cd: _vm.cd, uploadPhoto: _vm.uploadPhoto }))],1)}
var staticRenderFns = []

export { render, staticRenderFns }